<app-dialog-title>{{ 'are-you-sure' | transloco }}</app-dialog-title>

<mat-dialog-content class="content">
  <p>{{ 'this-will-process-all-no-qnr-tax-return-alias-s-in-this-population-click-process-button-to-continue-or-click-close-button-to-go-back' | transloco:{taxReturnAlias} }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="ui button" (click)="closeModal()">{{ 'close' | transloco }}</button>
  <button class="ui primary button" (click)="process()" [disabled]="bulkProcessing">{{ 'process' | transloco }}</button>
</mat-dialog-actions>
